import React from "react";
import AInput from "views/pages/manage/common/formFeilds/customInput/AInput";
import { customStyle, inputAmountStyle, numberDecimalLimitRegex } from "../../../components/constant";

const AmountInput = ({
  value,
  onChange,
  placeholder = "Enter amount",
  disabled = false,
  isView,
}) => {
  const handleInputChange = (value) => {
    if (!value || parseFloat(value) > 0) {
      onChange(
        value
          .replace(/[^0-9.]/g, "")
          .replace(/(\..*)\./g, "$1")
          .replace(/(\.\d{1,2}).*/g, "$1")
      );
    }
  };

  // const handleKeyPress = (e) => {
  //   if (!/^[0-9]*$/.test(String.fromCharCode(e.charCode))) {
  //     e.preventDefault();
  //   }
  // };

  return (

    <div className="input-container flex-fill">
      <span className="mb-1 semi-bold text-dark">Enter Amount</span>
      <div className="input-wrapper mt-1">
        <AInput
          value={value}
          customIcon={<div className="large-semi-bold">&#8377;</div>}
          handler={handleInputChange}
          //onKeyPress={handleKeyPress}
          //maxLength={10}
          placeholder="Enter amount"
          style={{...inputAmountStyle, borderRadius:"8px"}}
          disabled={isView}
          customIconStyle={customStyle}
          regex={numberDecimalLimitRegex(10, 2)}
        />
      </div>
    </div>
  );
};

export default AmountInput;
